export default __webpack_public_path__ + "static/media/landingLogo.319f056a.svg";